if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      /* — éléments du composant — */
      this.elements = {
        liveRegion : this.querySelector('[id^="GalleryStatus"]'),
        viewer     : this.querySelector('[id^="GalleryViewer"]'),
        thumbnails : this.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');

      /* ---------- listeners communs (toujours utiles) ---------- */
      this.elements.viewer.addEventListener(
        'slideChanged',
        debounce(this.onSlideChanged.bind(this), 500)
      );

      /* ---------- listeners propres aux vignettes ---------- */
      if (this.elements.thumbnails) {
        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const btn = mediaToSwitch.querySelector('button');
            if (btn)
              btn.addEventListener(
                'click',
                this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
              );
          });

        /* accessibilité desktop : retirer rôle liste s’il y a des vignettes + viewport ≥ 750 px */
        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }
    }

    /* --------------------------------------------------------- */
    onSlideChanged(event) {
      /* si pas de vignettes → on met à jour le média actif et on sort */
      if (!this.elements.thumbnails) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${event.detail.currentElement.dataset.mediaId}"]`
        );
        if (activeMedia) this.playActiveMedia(activeMedia);
        return;
      }

      /* logique standard quand les vignettes existent */
      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
      );
      const activeMedia = this.elements.viewer.querySelector(
        `[data-media-id="${event.detail.currentElement.dataset.mediaId}"]`
      );

      this.elements.viewer
        .querySelectorAll('[data-media-id]')
        .forEach((el) => el.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      this.setActiveThumbnail(thumbnail);
      this.playActiveMedia(activeMedia);
    }

    /* --------------------------------------------------------- */
    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(
        `[data-media-id="${mediaId}"]`
      );
      this.elements.viewer
        .querySelectorAll('[data-media-id]')
        .forEach((el) => el.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
      });

      this.playActiveMedia(activeMedia);

      /* gestion des vignettes facultatives */
      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${mediaId}"]`
      );
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    /* --------------------------------------------------------- */
    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails
        .querySelectorAll('button')
        .forEach((el) => el.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    /* --------------------------------------------------------- */
    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    /* --------------------------------------------------------- */
    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (!deferredMedia) return;

      /* ➜  au lieu de tout arrêter, on ne met en pause
            que les médias qui ne sont pas le courant  */
 /*     document
        .querySelectorAll('.deferred-media')
        .forEach(dm => { if (dm !== deferredMedia){ 
          dm.pause(); 
        }}); 
    
      /* charge + lance directement */
      deferredMedia.loadContent(true);      // true = autoplay immédiat
      let vid = document.getElementById("pro_video");
      vid.play();
    }


    preventStickyHeader() {
      this.stickyHeader =
        this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach((slide) =>
        slide.setAttribute('role', 'presentation')
      );
    }
  });
}
